namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    export class SortingAndGroupingControl extends Solovis.UI.BaseControl {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _sortByDiv: JQuery;
        public _sortBySelectorDiv: JQuery;
        public _sortBySelectorControlHost: Solovis.UI.ControlHost;
        public _groupByDiv: JQuery;
        public _groupBySelectorDiv: JQuery;
        public _groupBySelectorControlHost: Solovis.UI.ControlHost;
        public _expandCollapseAllDiv: JQuery;
        public _sortBySelectorControl: Solovis.UI.SmallOrderedListBuilder;


        constructor(options) {
            super(options);

            this.tableControl = options.tableControl;
        }

        public doInit() {
            var self = this;

            this.bindEventUntilControlDestroyed(this.tableControl.sortManager, "sortsChanged", function () { self._handleSortsChanged(); });
            this.bindEventUntilControlDestroyed(this.tableControl.groupManager, "groupsChanged", function () { self._handleGroupsChanged(); });
        }

        public doRender() {
            let self = this;

            let formDiv = $("<div>").appendTo(this.container);

            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            formBuilder.addEntry({
                name: "sortBy",
                label: "Sort By",
           
                createEditor: function (createEditorOptions) {
                    createEditorOptions.container.css("padding-top", "8px");

                    // Sorting
                    self._sortByDiv = createEditorOptions.container;
                    
                    self._sortBySelectorDiv = $("<div>").css("display", "inline-block").appendTo(self._sortByDiv);
                    self._sortBySelectorControlHost = new Solovis.UI.ControlHost({ container: self._sortBySelectorDiv });

                    return {};
                }
            });

            formBuilder.addEntry({
                name: "groupBy",
                label: "Group By",

                createEditor: function (createEditorOptions) {
                    createEditorOptions.container.css("padding-top", "8px");

                    // Grouping
                    self._groupByDiv = createEditorOptions.container;
                    
                    self._groupBySelectorDiv = $("<div>").css("display", "inline-block").appendTo(self._groupByDiv);
                    self._groupBySelectorControlHost = new Solovis.UI.ControlHost({ container: self._groupBySelectorDiv });
   
                    return {};
                }
            });

            formBuilder.addEntry({
                name: "expandCollapse",
                label: "Expand/Collapse",

                createEditor: function (createEditorOptions) {                   
                    self._expandCollapseAllDiv = $("<div>").appendTo(createEditorOptions.container);
                    var expandAllButton = $("<button>").text("Expand All").appendTo(self._expandCollapseAllDiv);
                    var collapseAllButton = $("<button>").text("Collapse All").appendTo(self._expandCollapseAllDiv);

                    expandAllButton.click(function () { self.tableControl.expansionManager.expandAll(); });
                    collapseAllButton.click(function () { self.tableControl.expansionManager.collapseAll(); });

                    return {};
                }
            });

            formBuilder.addEntry({
                name: "filterMode",
                label: "Filter Mode",

                initialValue: this.tableControl.filterFirst() ? "FilterFirst" : "FilterAfter",

                createEditor: function (createEditorOptions) {

                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        data: [
                            { text: "After Grouping/Aggregation", value: "FilterAfter" },
                            { text: "Before Grouping/Aggregation", value: "FilterFirst" }
                        ],
                        value: createEditorOptions.initialValue,

                        change: function () {
                            let val = editorControl.value();
                            if (val === "FilterFirst") {
                                self.tableControl.filterFirst(true);
                            }
                            else {
                                self.tableControl.filterFirst(false);
                            }
                        }
                    });

                    return editorControl;
                }
            });

            formBuilder.setupDone();          

            this._updateSortSelector();
            this._updateGroupSelector();
            
            $(this.tableControl.sortManager).bind("sortByChanged", function (e, data) {                
                if (data.commandSource !== "SortingAndGroupingControl") {
                    self._updateSortSelector();
                }
            } as any);
        }

        public _updateSortSelector() {
            var self = this;

            var sorts = this.tableControl.sortManager.getAvailableSorts();
            if (sorts && sorts.length > 0) {
                var sortByList = this.tableControl.sortManager.getSortByList();
                var sortByIds = _.map(sortByList, function (d: any) { return d.id });

                var sortItems = [];
                $(sorts).each(function (i, sortEntry: any) {
                    var sortItem = {
                        id: sortEntry.id,
                        label: sortEntry.label,
                        desc: Solovis.isNotNull(sortEntry.desc) ? sortEntry.desc : false
                    };

                    var matchingSortByEntry = _.find(sortByList, function (sortByEntry: any) {
                        return sortByEntry.id == sortEntry.id;
                    });

                    if (matchingSortByEntry && Solovis.isNotNull(matchingSortByEntry.desc)) {
                        sortItem.desc = matchingSortByEntry.desc;
                    }

                    sortItems.push(sortItem);
                });


                this._sortBySelectorControl = new Solovis.UI.SmallOrderedListBuilder({
                    allItems: sortItems,
                    currentItemIds: sortByIds,

                    itemElementContentGetter: function (item) {
                        var itemSpan = $("<span>");
                        $("<span>").text(item.label).appendTo(itemSpan);
                        itemSpan.append(" ");

                        var orderLink = $("<a>").appendTo(itemSpan);

                        var updateOrderLabel = function () {
                            orderLink.text(item.desc ? "(desc)" : "(asc)");
                        };

                        orderLink.click(function () {
                            item.desc = !item.desc;
                            updateOrderLabel();

                            $(self._sortBySelectorControl).trigger("itemsChanged");
                        });

                        updateOrderLabel();

                        return itemSpan;
                    }
                });
                this._sortBySelectorControlHost.setCurrentControl(this._sortBySelectorControl);

                $(this._sortBySelectorControl).bind("itemsChanged", function () {
                    var currentItems = self._sortBySelectorControl.getCurrentItems();
                    var newSortByList = _.map(currentItems, function (item) { return { id: item.id, desc: item.desc }; });

                    self.tableControl.sortManager.updateSortByList(newSortByList, "SortingAndGroupingControl");
                });

                $(this._sortByDiv).toggle(true);
            }
            else {
                this._sortBySelectorControlHost.setCurrentControl(null);
                $(this._sortByDiv).toggle(false);
            }
        };

        public _updateGroupSelector = function () {
            var self = this;

            var groups = this.tableControl.groupManager.getAvailableGroups();
            if (groups && groups.length > 0) {
                var groupByList = this.tableControl.groupManager.getGroupByList();
                var groupByIds = _.map(groupByList, function (d: any) { return d.id });

                this._groupBySelectorControl = new Solovis.UI.SmallOrderedListBuilder({
                    allItems: groups,
                    currentItemIds: groupByIds
                });
                this._groupBySelectorControlHost.setCurrentControl(this._groupBySelectorControl);

                $(this._groupBySelectorControl).bind("itemsChanged", function () {
                    var currentItems = self._groupBySelectorControl.getCurrentItems();
                    var currentItemIds = _.map(currentItems, function (d: any) { return d.id });

                    self.tableControl.groupManager.updateGroupByList(currentItemIds);
                });

                $(this._groupByDiv).toggle(true);
            }
            else {
                this._groupBySelectorControlHost.setCurrentControl(null);
                $(this._groupByDiv).toggle(false);
            }
        };

        public _handleSortsChanged = function () {
            this._updateSortSelector();
        };

        public _handleGroupsChanged = function () {
            this._updateGroupSelector();
        };
    }

}
